import { CapoPlugin } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];